import IPromotionRepository from 'domain/interfaces/repositories/IPromotionRepository'

export const inactivePromotionCommand = (
  repository: IPromotionRepository,
  promotionId: string,
  active: boolean,
) => {
  return repository.inactivePromotion(promotionId, active)
}
